import camelize from 'camelcase-keys-deep';

export default class QuestionAnswer {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  question() {
    return this.env().Question.findBy('id', this.questionId);
  }
}
